const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './pages/Dashboard/index')
const Top = () => import(/* webpackChunkName: "top" */ './pages/Top/index')
const SupplierPLList = () => import(/* webpackChunkName: "supplier-pl" */ './pages/Supplier/PL/List/index')
const SupplierPLColumn = () => import(/* webpackChunkName: "supplier-pl-column" */ './pages/Supplier/PL/Column/index')
const SupplierVariety = () => import(/* webpackChunkName: "supplier-variety" */ './pages/Supplier/Variety/index')
const SupplierSize = () => import(/* webpackChunkName: "supplier-size" */ './pages/Supplier/Size/index')
const SupplierBoxType = () => import(/* webpackChunkName: "supplier-box-type" */ './pages/Supplier/BoxType/index')
const SupplierUnit = () => import(/* webpackChunkName: "supplier-unit" */ './pages/Supplier/Unit/index')
const ChartInput = () => import(/* webpackChunkName: "chart-input" */ './pages/Chart/Input/index')
const ChartList = () => import(/* webpackChunkName: "chart-list" */ './pages/Chart/List/index')
const ChartOutput = () => import(/* webpackChunkName: "chart-output" */ './pages/Chart/Output/index')
const Bp = () => import(/* webpackChunkName: "bp" */ './pages/Bp/index')
const BillClosing = () => import(/* webpackChunkName: "bill-closing" */ './pages/Bill/Closing/index')
const BillPrint = () => import(/* webpackChunkName: "bill-print" */ './pages/Bill/Print/index')
const Genus = () => import(/* webpackChunkName: "genus" */ './pages/Master/Genus/index')
const Item = () => import(/* webpackChunkName: "item" */ './pages/Master/Item/index')
const Variety = () => import(/* webpackChunkName: "variety" */ './pages/Master/Variety/index')
const Size = () => import(/* webpackChunkName: "size" */ './pages/Master/Size/index')
const Color = () => import(/* webpackChunkName: "color" */ './pages/Master/Color/index')
const Option = () => import(/* webpackChunkName: "option" */ './pages/Master/Option/index')
const Regular = () => import(/* webpackChunkName: "regular" */ './pages/Regular/index')
const RegularAllocation = () => import(/* webpackChunkName: "regular-allocation" */ './pages/Regular/Allocation/index')
const Contact = () => import(/* webpackChunkName: "contact" */ './pages/Contact/index')
const FinanceTofill = () => import(/* webpackChunkName: "finance-to-fill" */ './pages/Finance/Tofill/index')
const FinanceTofillViewer = () => import(/* webpackChunkName: "finance-to-fill-viewer" */ './pages/Finance/Tofill/viewer')
const CustomerClaim = () => import(/* webpackChunkName: "customer-claim" */ './pages/Customer/Claim/index')
const CustomerClaimView = () => import(/* webpackChunkName: "customer-claim-view" */ './pages/Customer/Claim/View/index')
const PlFetch = () => import(/* webpackChunkName: "pl-fetch" */ './pages/Pl/Fetch/index')
const StockInput = () => import(/* webpackChunkName: "stock-input" */ './pages/Stock/Input/index')
const StockFM = () => import(/* webpackChunkName: "stock-FM" */ './pages/Stock/FM/index')
const InvoicePrint = () => import(/* webpackChunkName: "invoice-print" */ './pages/Invoice/Print/index')
const InvoiceTransmission = () => import(/* webpackChunkName: "invoice-transmission" */ './pages/Invoice/Transmission/index')
const RegularCycle = () => import(/* webpackChunkName: "regular-cycle" */ './pages/Master/Regular/Cycle/index')
const ContactType = () => import(/* webpackChunkName: "contact-type" */ './pages/Master/Contact/Type/index')
const Country = () => import(/* webpackChunkName: "country" */ './pages/Master/Country/index')
const Customer = () => import(/* webpackChunkName: "customer" */ './pages/Master/Customer/index')
const CustomerCommonHoliday = () => import(/* webpackChunkName: "customer-common-holiday" */ './pages/Master/Customer/Common/Holiday/index')
const CustomerHoliday = () => import(/* webpackChunkName: "customer-holiday" */ './pages/Master/Customer/Holiday/index')
const Region = () => import(/* webpackChunkName: "region" */ './pages/Master/Region/index')
const Supplier = () => import(/* webpackChunkName: "supplier" */ './pages/Master/Supplier/index')
const Forward = () => import(/* webpackChunkName: "forward" */ './pages/Master/Forward/index')
const Timetable = () => import(/* webpackChunkName: "timetable" */ './pages/Timetable/index')
const RepackTimetable = () => import(/* webpackChunkName: "repack-timetable" */ './pages/Repack/Timetable/index')
const RepackPc1 = () => import(/* webpackChunkName: "repack-pc1" */ './pages/Repack/Pc1/index')
const RepackPc2 = () => import(/* webpackChunkName: "repack-pc2" */ './pages/Repack/Pc2/index')
const RepackPc3 = () => import(/* webpackChunkName: "repack-pc3" */ './pages/Repack/Pc3/index')
const Filetype = () => import(/* webpackChunkName: "file-type" */ './pages/Master/Filetype/index')
const FumigationCompany = () => import(/* webpackChunkName: "fumigation-company" */ './pages/Master/Fumigation/Company/index')
const FumigationType = () => import(/* webpackChunkName: "fumigation-type" */ './pages/Master/Fumigation/Type/index')
const Port = () => import(/* webpackChunkName: "port" */ './pages/Master/Port/index')
const Uwaya = () => import(/* webpackChunkName: "uwaya" */ './pages/Master/Uwaya/index')
const OptionsBp = () => import(/* webpackChunkName: "options-bp" */ './pages/Master/Options/Bp/index')
const OptionsPq = () => import(/* webpackChunkName: "options-pq" */ './pages/Master/Options/Pq/index')
const AwbToUwaya = () => import(/* webpackChunkName: "awb-to-uwaya" */ './pages/Master/Awb/To/Uwaya/index')
const HanshutsuStatus = () => import(/* webpackChunkName: "hanshutsu-status" */ './pages/Master/Hanshutsu/Status/index')
const Setting = () => import(/* webpackChunkName: "setting" */ './pages/Master/Setting/index')
const FMSellingStatus = () => import(/* webpackChunkName: "fm-selling-status" */ './pages/Master/FMSellingStatus/index')
const Receipt = () => import(/* webpackChunkName: "receipt" */ './pages/Receipt/index')
const ReceiptCheck = () => import(/* webpackChunkName: "receipt-check" */ './pages/Receipt/Check/index')
const ReceiptView = () => import(/* webpackChunkName: "receipt-view" */ './pages/Receipt/View/index')
const Temperature = () => import(/* webpackChunkName: "temperature" */ './pages/Master/Temperature/index')
const TemperatureState = () => import(/* webpackChunkName: "temperature-state" */ './pages/Master/Temperature/State/index')
const TemperaturePreset = () => import(/* webpackChunkName: "temperature-preset" */ './pages/Master/Temperature/Preset/index')
const SupplierRequired = () => import(/* webpackChunkName: "supplier-required" */ './pages/Master/Supplier/Required/index')
const RepackPreset = () => import(/* webpackChunkName: "repack-preset" */ './pages/Master/Repack/Preset/index')
const Payee = () => import(/* webpackChunkName: "payee" */ './pages/Master/Payee/index')
const PayeeBank = () => import(/* webpackChunkName: "payee-bank" */ './pages/Master/Payee/Bank/index')
const JournalSearch = () => import(/* webpackChunkName: "journal-search" */ './pages/Journal/Search/index')
const JournalAggregator = () => import(/* webpackChunkName: "journal-aggregator" */ './pages/Journal/Aggregator/index')
const JournalCountry = () => import(/* webpackChunkName: "journal-country" */ './pages/Journal/Country/index')
const SalesAmountStatus = () => import(/* webpackChunkName: "sales-amount-status" */ './pages/Sales/Amount/Status/index')
const CustomerSummary = () => import(/* webpackChunkName: "customer-summary" */ './pages/Customer/Summary/index')
const ProductStatistic = () => import(/* webpackChunkName: "product-statistic" */ './pages/Statistic/Product/index')
const ItemRanking = () => import(/* webpackChunkName: "item-ranking" */ './pages/Item/Ranking/index')
const Urizan = () => import(/* webpackChunkName: "urizan" */ './pages/Urizan/index')
const SalesDifference = () => import(/* webpackChunkName: "sales-difference" */ './pages/Sales/Difference/index')
const FumigationRequest = () => import(/* webpackChunkName: "fumigation-request" */ './pages/Fumigation/Request/index')
const Statement = () => import(/* webpackChunkName: "statement" */ './pages/Statement/index')
const BeneficiaryBank = () => import(/* webpackChunkName: "beneficiary-bank" */ './pages/Master/Beneficiary/Bank/index')
const BeneficiaryBankBranch = () => import(/* webpackChunkName: "beneficiary-bank-branch" */ './pages/Master/Beneficiary/Bank/Branch/index')
const PaymentReason = () => import(/* webpackChunkName: "payment-reason" */ './pages/Master/Payment/Reason/index')
const PaymentClosingPattern = () => import(/* webpackChunkName: "payment-closing-pattern" */ './pages/Master/Payment/Closing/Pattern/index')
const Classification = () => import(/* webpackChunkName: "classification" */ './pages/Master/Classification/index')
const Currency = () => import(/* webpackChunkName: "currency" */ './pages/Master/Currency/index')
const SalesInput = () => import(/* webpackChunkName: "sales-input" */ './pages/Sales/Input/index')
const BillDocument = () => import(/* webpackChunkName: "sales-input" */ './pages/BillDocument/index')
const CustomerBalance = () => import(/* webpackChunkName: "customer-balance" */ './pages/Customer/Balance/index')
const CustomerBalanceManagement = () => import(/* webpackChunkName: "customer-balance-management" */ './pages/Customer/Balance/Management/index')
const DpMaker = () => import(/* webpackChunkName: "dp-maker" */ './pages/Master/Dp/Maker/index')
const LogiCenterForward = () => import(/* webpackChunkName: "logi-center-forward" */ './pages/LogiCenterForward/index')
const BoxTypeDicision = () => import(/* webpackChunkName: "box-typ-decision" */ './pages/Master/Box/Type/Dicision/index')
const Unit = () => import(/* webpackChunkName: "unit" */ './pages/Master/Unit/index')
const Worm = () => import(/* webpackChunkName: "worm" */ './pages/Master/Worm/index')
const DeliveryArea = () => import(/* webpackChunkName: "delivery-area" */ './pages/Master/Delivery/Area/index')
const DeliveryCompany = () => import(/* webpackChunkName: "delivery-company" */ './pages/Master/Delivery/Company/index')
const DeliveryUnitCost = () => import(/* webpackChunkName: "delivery-unit-cost" */ './pages/Master/Delivery/Unit/Cost/index')
const Kshipment = () => import(/* webpackChunkName: "kshipment" */ './pages/Kshipment/index')
const BoxType = () => import(/* webpackChunkName: "box-type" */ './pages/Master/Box/Type/index')
const TaxRate = () => import(/* webpackChunkName: "tax-rate" */ './pages/Master/Tax/Rate/index')
const LogiCenter = () => import(/* webpackChunkName: "logi-center" */ './pages/Master/Logi/Center/index')
const Bank = () => import(/* webpackChunkName: "bank" */ './pages/Master/Bank/index')
const BankBranch = () => import(/* webpackChunkName: "bank-branch" */ './pages/Master/Bank/Branch/index')
const BillItem = () => import(/* webpackChunkName: "bill-item" */ './pages/Master/Bill/Item/index')
const BillClosingPattern = () => import(/* webpackChunkName: "bill-closing-pattern" */ './pages/Master/Bill/Closing/Pattern/index')
const UwayaPort = () => import(/* webpackChunkName: "uwaya-port" */ './pages/Master/Uwaya/Port/index')
const FumigationCompanyPort = () => import(/* webpackChunkName: "fumigation-company-port" */ './pages/Master/Fumigation/Company/Port/index')
const RepackLine = () => import(/* webpackChunkName: "repack-line" */ './pages/Master/Repack/Line/index')
const RepackPlace = () => import(/* webpackChunkName: "repack-place" */ './pages/Master/Repack/Place/index')
const StockRemaining = () => import(/* webpackChunkName: "stock-remaining" */ './pages/Stock/Remaining/index')
const FinanceUnpaid = () => import(/* webpackChunkName: "finance-unpaid" */ './pages/Finance/Unpaid/index')
const ExcelToStock = () => import(/* webpackChunkName: "excel-to-stock" */ './pages/Master/Excel/toStock/index')
const ClaimReport = () => import(/* webpackChunkName: "claim-report" */ './pages/Claim/Report/index')
const SalesReport = () => import(/* webpackChunkName: "sales-report" */ './pages/Sales/Report/index')
const ImportApi = () => import(/* webpackChunkName: "import-api" */ './pages/Import/Api/index')
const FlashReport = () => import(/* webpackChunkName: "flash-report" */ './pages/Flash/Report/index')
const StockStatus = () => import(/* webpackChunkName: "stock-status" */ './pages/Master/StockStatus/index')
const OrderReceipt = () => import(/* webpackChunkName: "order-receipt" */ './pages/Order/Receipt/index')
const Motochou = () => import(/* webpackChunkName: "motochou" */ './pages/Sales/Motochou/index')
const NotificationType = () => import(/* webpackChunkName: "notification-type" */ './pages/Master/Notification/Type/index')
const BillList = () => import(/* webpackChunkName: "bill-list" */ './pages/Bill/List/index')
const DamageType = () => import(/* webpackChunkName: "damage-type" */ './pages/Master/DamageType/index')
const MarketFlash = () => import(/* webpackChunkName: "market-flash" */ './pages/Market/Flash/index')
const SalesView = () => import(/* webpackChunkName: "sales-view" */ './pages/Sales/View/index')
const BillBalance = () => import(/* webpackChunkName: "bill-balance" */ './pages/Master/Bill/Balance/index')
const StatementBalance = () => import(/* webpackChunkName: "statement_balance" */ './pages/Master/Statement/Balance/index')
const ContactStatus = () => import(/* webpackChunkName: "contact_status" */ './pages/Contact/Status')

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, requiresRoles: ['basic'] }
  },
  {
    path: '/top',
    name: 'top',
    component: Top,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/supplier_pl',
    name: 'supplier_pl',
    redirect: '/supplier_pl_list'
  },
  {
    path: '/supplier_pl/list',
    name: 'supplier_pl_list',
    component: SupplierPLList,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/supplier_pl/column',
    name: 'supplier_pl_column',
    component: SupplierPLColumn,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/supplier/variety',
    name: 'supplier_variety',
    component: SupplierVariety,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/supplier/size',
    name: 'supplier_size',
    component: SupplierSize,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/supplier/box_type',
    name: 'supplier_box_type',
    component: SupplierBoxType,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/supplier/unit',
    name: 'supplier_unit',
    component: SupplierUnit,
    meta: { requiresAuth: true, requiresRoles: ['supplier'] }
  },
  {
    path: '/chart',
    name: 'chart',
    redirect: '/chart_list'
  },
  {
    path: '/chart_list',
    name: 'chart_list',
    component: ChartList,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/chart_input',
    name: 'chart_input',
    component: ChartInput,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/chart_output',
    name: 'chart_output',
    component: ChartOutput,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/bp',
    name: 'bp',
    component: Bp,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/bill/closing',
    name: 'bill_closing',
    component: BillClosing,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/bill/print',
    name: 'bill_print',
    component: BillPrint,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/urizan',
    name: 'urizan',
    component: Urizan,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/sales/difference',
    name: 'sales_difference',
    component: SalesDifference,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/finance/tofill',
    name: 'finance_tofill',
    component: FinanceTofill,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/finance/tofill/viewer/:ids',
    name: 'finance_tofill_viewer',
    component: FinanceTofillViewer,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/customer/claim',
    name: 'customer_claim',
    component: CustomerClaim,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/customer/claim_view',
    name: 'customer_claim_view',
    component: CustomerClaimView,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/customer/summary',
    name: 'customer_summary',
    component: CustomerSummary,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/product_statistic',
    name: 'product_statistic',
    component: ProductStatistic,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/product_statistic/:hisId',
    name: 'product_statistic_hisId',
    component: ProductStatistic,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/item/ranking',
    name: 'item_ranking',
    component: ItemRanking,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/genus',
    name: 'genus',
    component: Genus,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/item',
    name: 'item',
    component: Item,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/variety',
    name: 'variety',
    component: Variety,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/size',
    name: 'size',
    component: Size,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/color',
    name: 'color',
    component: Color,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/option',
    name: 'option',
    component: Option,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/regular_cycle',
    name: 'regular_cycle',
    component: RegularCycle,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/regular',
    name: 'regular',
    component: Regular,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/regular_allocation',
    name: 'regular_allocation',
    component: RegularAllocation,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/pl/fetch',
    name: 'pl_fetch',
    component: PlFetch,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/stock/input',
    name: 'stock_input',
    component: StockInput,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/stock/input/:shpid',
    name: 'stock_input_shpid',
    component: StockInput,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/stock/fm/:shpid',
    name: 'stock_fm',
    component: StockFM,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/contact_type',
    name: 'contact_type',
    component: ContactType,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/country',
    name: 'country',
    component: Country,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/customer',
    name: 'customer',
    component: Customer,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/customer_common_holiday',
    name: 'customer_common_holiday',
    component: CustomerCommonHoliday,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/customer_holiday',
    name: 'customer_holiday',
    component: CustomerHoliday,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/region',
    name: 'region',
    component: Region,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/supplier',
    name: 'supplier',
    component: Supplier,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/forward',
    name: 'forward',
    component: Forward,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/timetable',
    name: 'timetable',
    component: Timetable,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/repack/timetable',
    name: 'repack_timetable',
    component: RepackTimetable,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/repack/input/:id',
    name: 'repack_input',
    component: RepackTimetable,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/repack/pc1/:place/:line',
    name: 'repack_pc_1',
    component: RepackPc1,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/repack/pc2/:place/:line',
    name: 'repack_pc_2',
    component: RepackPc2,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/repack/pc3/:place/:line',
    name: 'repack_pc_3',
    component: RepackPc3,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/invoice/print',
    name: 'invoice_print',
    component: InvoicePrint,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/sales/amount/status',
    name: 'sales_amount_status',
    component: SalesAmountStatus,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/journal/search',
    name: 'journal_search',
    component: JournalSearch,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/journal/aggregator',
    name: 'journal_aggregator',
    component: JournalAggregator,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/journal/country',
    name: 'journal_country',
    component: JournalCountry,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/invoice/transmission',
    name: 'invoice_transmission',
    component: InvoiceTransmission,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/fumigation/request',
    name: 'fumigation_request',
    component: FumigationRequest,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/filetype',
    name: 'filetype',
    component: Filetype,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/temperature',
    name: 'temperature',
    component: Temperature,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/temperature_state',
    name: 'temperature_state',
    component: TemperatureState,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/temperature_preset',
    name: 'temperature_preset',
    component: TemperaturePreset,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/fumigation_company',
    name: 'fumigation_company',
    component: FumigationCompany,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/fumigation_type',
    name: 'fumigation_type',
    component: FumigationType,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/port',
    name: 'port',
    component: Port,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/uwaya',
    name: 'uwaya',
    component: Uwaya,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/options_bp',
    name: 'options_bp',
    component: OptionsBp,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/options_pq',
    name: 'options_pq',
    component: OptionsPq,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/awb_to_uwaya',
    name: 'awb_to_uwaya',
    component: AwbToUwaya,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/hanshutsu_status',
    name: 'hanshutsu_status',
    component: HanshutsuStatus,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/setting',
    name: 'setting',
    component: Setting,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/supplier_required',
    name: 'supplier_required',
    component: SupplierRequired,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/repack_preset',
    name: 'repack_preset',
    component: RepackPreset,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/payee',
    name: 'payee',
    component: Payee,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/payee_bank',
    name: 'payee_bank',
    component: PayeeBank,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/beneficiary_bank',
    name: 'beneficiary_bank',
    component: BeneficiaryBank,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/beneficiary_bank_branch',
    name: 'beneficiary_bank_branch',
    component: BeneficiaryBankBranch,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/payment_reason',
    name: 'payment_reason',
    component: PaymentReason,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/payment_closing_pattern',
    name: 'payment_closing_pattern',
    component: PaymentClosingPattern,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/classification',
    name: 'classification',
    component: Classification,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/currency',
    name: 'currency',
    component: Currency,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/receipt',
    name: 'receipt',
    component: Receipt,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/receipt/check',
    name: 'receipt_check',
    component: ReceiptCheck,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/receipt/view',
    name: 'receipt_view',
    component: ReceiptView,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/statement',
    name: 'statement',
    component: Statement,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/sales/input',
    name: 'sales_input',
    component: SalesInput,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/bill/document',
    name: 'bill_document',
    component: BillDocument,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/customer/balance',
    name: 'customer_balance',
    component: CustomerBalance,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/customer/balance_management',
    name: 'customer_balance_management',
    component: CustomerBalanceManagement,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/dp_maker',
    name: 'dp_maker',
    component: DpMaker,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/fm_selling_status',
    name: 'fm_selling_status',
    component: FMSellingStatus,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/logi_center_forward',
    name: 'logi_center_forward',
    component: LogiCenterForward,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/worm',
    name: 'worm',
    component: Worm,
    meta: {requiresAuth: true, requiresRoles: ['manager']}
  },
  {
    path: '/master/box_type/dicision',
    name: 'box_type_dicision',
    component: BoxTypeDicision,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/unit',
    name: 'unit',
    component: Unit,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/worm',
    name: 'worm',
    component: Worm,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/delivery_area',
    name: 'delivery_area',
    component: DeliveryArea,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/delivery_company',
    name: 'delivery_company',
    component: DeliveryCompany,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/delivery_unit_cost',
    name: 'delivery_unit_cost',
    component: DeliveryUnitCost,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/kshipment',
    name: 'Kshipment',
    component: Kshipment,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/box/type',
    name: 'box_type',
    component: BoxType,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/tax/rate',
    name: 'tax_rate',
    component: TaxRate,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/logi/center',
    name: 'logi_center',
    component: LogiCenter,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/bank',
    name: 'bank',
    component: Bank,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/bank_branch',
    name: 'bank_branch',
    component: BankBranch,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/bill_item',
    name: 'bill_item',
    component: BillItem,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/bill/closing/pattern',
    name: 'bill_closing_pattern',
    component: BillClosingPattern,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/uwaya_port',
    name: 'uwaya_port',
    component: UwayaPort,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/fumigation_company_port',
    name: 'fumigation_company_port',
    component: FumigationCompanyPort,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/repack_line',
    name: 'repack_line',
    component: RepackLine,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/repack_place',
    name: 'repack_place',
    component: RepackPlace,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/stock/remaining',
    name: 'stock_remaining',
    component: StockRemaining,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/finance/unpaid',
    name: 'finance_unpaid',
    component: FinanceUnpaid,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/excel/to_stock',
    name: 'excel_to_stock',
    component: ExcelToStock,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/claim/report',
    name: 'claim_report',
    component: ClaimReport,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/sales/report',
    name: 'sales_report',
    component: SalesReport,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/import/api',
    name: 'import_api',
    component: ImportApi,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/flash/report',
    name: 'flash_report',
    component: FlashReport,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/stock_status',
    name: 'stock_status',
    component: StockStatus,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/order/receipt',
    name: 'order_receipt',
    component: OrderReceipt,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/sales/ledger',
    name: 'motochou',
    component: Motochou,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/notification_type',
    name: 'notification_type',
    component: NotificationType,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/bill/list',
    name: 'bill_list',
    component: BillList,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/damage_type',
    name: 'damage_type',
    component: DamageType,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/market/flash',
    name: 'market_flash',
    component: MarketFlash,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/sales/view',
    name: 'sales_view',
    component: SalesView,
    meta: { requiresAuth: true, requiresRoles: ['user'] }
  },
  {
    path: '/master/bill_balance',
    name: 'bill_balance',
    component: BillBalance,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/statement_balance',
    name: 'statement_balance',
    component: StatementBalance,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  },
  {
    path: '/master/contact_status',
    name: 'contact_status',
    component: ContactStatus,
    meta: { requiresAuth: true, requiresRoles: ['manager'] }
  }
]



// WEBPACK FOOTER //
// ./src/app/routes.js